<template>
  <nav class="navbar navbar-inverse navbar-main yamm">
    <div class="container">
      <div class="navbar-header">
        <button
          class="navbar-toggle collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#main-nav-collapse"
          area_expanded="false"
        >
          <span class="sr-only">Main Menu</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link :to="{ name: 'home'}" class="navbar-brand">
          <img src="@/assets/img/logo-w.png" alt="Image Alternative text" title="Image Title" />
        </router-link>
      </div>
      <div class="collapse navbar-collapse" id="main-nav-collapse">
        <ul class="nav navbar-nav">
          <li class="dropdown">
            <router-link :to="{ name: 'categories'}">
              <i class="fa fa-reorder"></i>&nbsp; Shop by Category
              <i class="drop-caret" data-toggle="dropdown"></i>
            </router-link>
            <ul class="dropdown-menu dropdown-menu-category">
              <li>
                <a href="#">
                  <i class="fa fa-home dropdown-menu-category-icon"></i>Products
                </a>
                <div class="dropdown-menu-category-section">
                  <div class="dropdown-menu-category-section-inner">
                    <div class="dropdown-menu-category-section-content">
                      <div class="row">
                        <router-link class="menu-link" :to="{ name: 'categories'}">View All Products</router-link>
                        <div class="col-md-6">
                          <h5 class="dropdown-menu-category-title">Products</h5>
                          <ul class="dropdown-menu-category-list">
                            <li
                              v-bind:key="productCategory.CategoryId"
                              v-for="productCategory in recommendedProductCategories"
                            >
                              <router-link
                                :to="{ name: 'productsByCategory', params: { id: productCategory.CategoryId }}"
                              >{{productCategory.CategoryName}}</router-link>
                              <p>{{productCategory.ShortDescription}}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- <img class="dropdown-menu-category-section-theme-img" src="@/assets/img/test_cat/2-i.png" alt="Image Alternative text" title="Image Title" style="right: -10px;" /> -->
                  </div>
                </div>
              </li>
              <li>
                <a href="#">
                  <i class="fa fa-home dropdown-menu-category-icon"></i>Services
                </a>
                <div class="dropdown-menu-category-section">
                  <div class="dropdown-menu-category-section-inner">
                    <div class="dropdown-menu-category-section-content">
                      <div class="row">
                        <router-link class="menu-link" :to="{ name: 'categories'}">View All Services</router-link>
                        <div class="col-md-6">
                          <h5 class="dropdown-menu-category-title">Services</h5>
                          <ul class="dropdown-menu-category-list">
                            <li
                              v-bind:key="serviceCategory.CategoryId"
                              v-for="serviceCategory in recommendedServiceCategories"
                            >
                              <router-link
                                :to="{ name: 'servicesByCategory', params: { id: serviceCategory.CategoryId }}"
                              >{{serviceCategory.CategoryName}}</router-link>
                              <p>{{serviceCategory.CategoryName}}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- <img class="dropdown-menu-category-section-theme-img" src="@/assets/img/test_cat/2-i.png" alt="Image Alternative text" title="Image Title" style="right: -10px;" /> -->
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <form v-on:submit.prevent class="navbar-form navbar-left navbar-main-search" role="search">
          <div class="form-group">
            <input
              v-model="search"
              v-on:keyup.enter="submitSearch"
              class="form-control"
              type="text"
              placeholder="Search Product or Service or Company..."
            />
          </div>
          <a @click="submitSearch" class="fa fa-search navbar-main-search-submit" href="#"></a>
        </form>
        <ul class="nav navbar-nav navbar-right">
          <li :style="hilang()">
            <a v-bind:href="dashboardUrl" target="_blank">Dashboard</a>
          </li>
          <li :style="unAuthenticated()">
            <a href="#nav-login-dialog" data-effect="mfp-move-from-top" class="popup-text">Sign In</a>
          </li>
          <li :style="unAuthenticated()">
            <a
              href="#nav-account-dialog"
              data-effect="mfp-move-from-top"
              class="popup-text"
            >Register</a>
          </li>
          <!--<li v-if="isAuthenticated">
						<a href="#" data-effect="mfp-move-from-top" class="popup-text">{{currentUser.name}}</a>
          </li>-->
          <li v-if="isAuthenticated">
            <a href @click="singOut">Sign out</a>
          </li>
        </ul>
      </div>
    </div>
    <Login />
    <Register />
    <PasswordRecovery />
    <ChatBox />
    
    
    
  </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Login from "@/components/Login";
import Register from "@/components/Register";
import PasswordRecovery from "@/components/PasswordRecovery";
import api from "@/lib/api";
import ChatBox from "@/components/ChatBox";
import ChatUItwo from "@/components/ChatUItwo";

export default {
  components: {
    Login,
    Register,
    PasswordRecovery,
    ChatBox,
    // ChatUItwo
  },
  data() {
    return {
      search: this.$route.query.keyword,
      RowsPerPage: "10",
      PageNumber: "1",
      isChrome: this.checkIsChrome()
    };
  },
  created() {
    this.$store.dispatch("categories/fetchRecommendedCategories");
    //console.log("isChrome ::::::::::::::: ", this.isChrome);
    if (!this.isChrome) {
      this.$alert(
        "For the best view & experince, please use Google Chrome as your browser",
        "Alert"
      );
    }
  },
  computed: {
    ...mapState("categories", [
      "recommendedProductCategories",
      "recommendedServiceCategories"
    ]),
    ...mapGetters("user", ["isAuthenticated", "currentUser"]),
    dashboardUrl() {
      return this.isAuthenticated
        ? api.getHostDashboardUrl() +
            "/app/dashboard/menu?token=" +
            this.currentUser.token
        : api.getHostDashboardUrl();
      // return this.isAuthenticated ? "http://betadashboard.toolaku.com/account/login" : "http://betadashboard.toolaku.com/account/login"
      console.log('localStorage USER here is :::::::::: ', localStorage.getItem("user").id);
    }

  },
  methods: {
    hilang() {
      if (this.isAuthenticated) {
        return "display: block;";
      } else {
        return "display: none;";
      }
    },
    unAuthenticated() {
      if (!this.isAuthenticated) {
        return "display: block;";
      } else {
        return "display: none;";
      }
    },
    submitSearch() {
      this.$router.push({ name: "search", query: { keyword: this.search } });
    },
    singOut() {
      this.$store.dispatch("user/singOut");
    },
    checkIsChrome() {
      //this.$router.push({ name: 'search', query: { keyword: this.search } })
      var browserName = "";
      if (
        navigator.userAgent.indexOf("Edge") > -1 &&
        navigator.appVersion.indexOf("Edge") > -1
      ) {
        browserName =  "Edge";
      } else if (
        navigator.userAgent.indexOf("Opera") != -1 ||
        navigator.userAgent.indexOf("OPR") != -1
      ) {
        browserName = "Opera";
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        browserName = "Chrome";
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        browserName = "Safari";
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browserName = "Firefox";
      } else if (
        navigator.userAgent.indexOf("MSIE") != -1 ||
        !!document.documentMode == true
      ) {
        //IF IE > 10
        browserName = "IE";
      } else {
        browserName = "unknown";
      }

      return (
        // !!window["chrome"] &&
        // (!!window["chrome"]["webstore"] || !!window["chrome"]["runtime"])
        //navigator.userAgent.indexOf("Chrome") != -1
        browserName == "Chrome"
      );
    }
  }
};
</script>
